"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var function_1 = require("fp-ts/lib/function");
var Traversable_1 = require("fp-ts/lib/Traversable");
var Option_1 = require("fp-ts/lib/Option");
var Either_1 = require("fp-ts/lib/Either");
var Array_1 = require("fp-ts/lib/Array");
var Ordering_1 = require("fp-ts/lib/Ordering");
exports.URI = 'RemoteData';
var RemoteInitial = /** @class */ (function () {
    function RemoteInitial() {
        this._tag = 'RemoteInitial';
    }
    RemoteInitial.prototype.alt = function (fy) {
        return fy;
    };
    RemoteInitial.prototype.altL = function (fy) {
        return fy();
    };
    RemoteInitial.prototype.ap = function (fab) {
        return exports.initial; //tslint:disable-line no-use-before-declare
    };
    RemoteInitial.prototype.chain = function (f) {
        return exports.initial; //tslint:disable-line no-use-before-declare
    };
    RemoteInitial.prototype.extend = function (f) {
        return exports.initial; //tslint:disable-line no-use-before-declare
    };
    RemoteInitial.prototype.fold = function (initial, pending, failure, success) {
        return initial;
    };
    RemoteInitial.prototype.foldL = function (initial, pending, failure, success) {
        return initial();
    };
    RemoteInitial.prototype.getOrElseL = function (f) {
        return f();
    };
    RemoteInitial.prototype.map = function (f) {
        return exports.initial; //tslint:disable-line no-use-before-declare
    };
    RemoteInitial.prototype.mapLeft = function (f) {
        return exports.initial; //tslint:disable-line no-use-before-declare
    };
    RemoteInitial.prototype.getOrElse = function (value) {
        return value;
    };
    RemoteInitial.prototype.reduce = function (f, b) {
        return b;
    };
    RemoteInitial.prototype.isPending = function () {
        return false;
    };
    RemoteInitial.prototype.isFailure = function () {
        return false;
    };
    RemoteInitial.prototype.isSuccess = function () {
        return false;
    };
    RemoteInitial.prototype.isInitial = function () {
        return true;
    };
    RemoteInitial.prototype.toOption = function () {
        return Option_1.none;
    };
    RemoteInitial.prototype.toNullable = function () {
        return null;
    };
    RemoteInitial.prototype.toString = function () {
        return 'initial';
    };
    RemoteInitial.prototype.contains = function (S, a) {
        return false;
    };
    RemoteInitial.prototype.exists = function (p) {
        return false;
    };
    return RemoteInitial;
}());
exports.RemoteInitial = RemoteInitial;
var RemoteFailure = /** @class */ (function () {
    function RemoteFailure(error) {
        this.error = error;
        this._tag = 'RemoteFailure';
    }
    RemoteFailure.prototype.alt = function (fy) {
        return fy;
    };
    RemoteFailure.prototype.altL = function (fy) {
        return fy();
    };
    RemoteFailure.prototype.ap = function (fab) {
        var _this = this;
        return fab.fold(exports.initial, exports.pending, function () { return fab; }, function () { return _this; }); //tslint:disable-line no-use-before-declare
    };
    RemoteFailure.prototype.chain = function (f) {
        return this;
    };
    RemoteFailure.prototype.extend = function (f) {
        return this;
    };
    RemoteFailure.prototype.fold = function (initial, pending, failure, success) {
        return failure(this.error);
    };
    RemoteFailure.prototype.foldL = function (initial, pending, failure, success) {
        return failure(this.error);
    };
    RemoteFailure.prototype.getOrElseL = function (f) {
        return f();
    };
    RemoteFailure.prototype.map = function (f) {
        return this;
    };
    RemoteFailure.prototype.mapLeft = function (f) {
        return exports.failure(f(this.error)); //tslint:disable-line no-use-before-declare
    };
    RemoteFailure.prototype.getOrElse = function (value) {
        return value;
    };
    RemoteFailure.prototype.reduce = function (f, b) {
        return b;
    };
    RemoteFailure.prototype.isInitial = function () {
        return false;
    };
    RemoteFailure.prototype.isPending = function () {
        return false;
    };
    RemoteFailure.prototype.isFailure = function () {
        return true;
    };
    RemoteFailure.prototype.isSuccess = function () {
        return false;
    };
    RemoteFailure.prototype.toOption = function () {
        return Option_1.none;
    };
    RemoteFailure.prototype.toNullable = function () {
        return null;
    };
    RemoteFailure.prototype.toString = function () {
        return "failure(" + function_1.toString(this.error) + ")";
    };
    RemoteFailure.prototype.contains = function (S, a) {
        return false;
    };
    RemoteFailure.prototype.exists = function (p) {
        return false;
    };
    return RemoteFailure;
}());
exports.RemoteFailure = RemoteFailure;
var RemoteSuccess = /** @class */ (function () {
    function RemoteSuccess(value) {
        this.value = value;
        this._tag = 'RemoteSuccess';
    }
    RemoteSuccess.prototype.alt = function (fy) {
        return this;
    };
    RemoteSuccess.prototype.altL = function (fy) {
        return this;
    };
    RemoteSuccess.prototype.ap = function (fab) {
        var _this = this;
        return fab.fold(exports.initial, exports.pending, function () { return fab; }, function (value) { return _this.map(value); }); //tslint:disable-line no-use-before-declare
    };
    RemoteSuccess.prototype.chain = function (f) {
        return f(this.value);
    };
    RemoteSuccess.prototype.extend = function (f) {
        return of(f(this)); //tslint:disable-line no-use-before-declare
    };
    RemoteSuccess.prototype.fold = function (initial, pending, failure, success) {
        return success(this.value);
    };
    RemoteSuccess.prototype.foldL = function (initial, pending, failure, success) {
        return success(this.value);
    };
    RemoteSuccess.prototype.getOrElseL = function (f) {
        return this.value;
    };
    RemoteSuccess.prototype.map = function (f) {
        return of(f(this.value)); //tslint:disable-line no-use-before-declare
    };
    RemoteSuccess.prototype.mapLeft = function (f) {
        return this;
    };
    RemoteSuccess.prototype.getOrElse = function (value) {
        return this.value;
    };
    RemoteSuccess.prototype.reduce = function (f, b) {
        return f(b, this.value);
    };
    RemoteSuccess.prototype.isInitial = function () {
        return false;
    };
    RemoteSuccess.prototype.isPending = function () {
        return false;
    };
    RemoteSuccess.prototype.isFailure = function () {
        return false;
    };
    RemoteSuccess.prototype.isSuccess = function () {
        return true;
    };
    RemoteSuccess.prototype.toOption = function () {
        return Option_1.some(this.value);
    };
    RemoteSuccess.prototype.toNullable = function () {
        return this.value;
    };
    RemoteSuccess.prototype.toString = function () {
        return "success(" + function_1.toString(this.value) + ")";
    };
    RemoteSuccess.prototype.contains = function (S, a) {
        return S.equals(this.value, a);
    };
    RemoteSuccess.prototype.exists = function (p) {
        return p(this.value);
    };
    return RemoteSuccess;
}());
exports.RemoteSuccess = RemoteSuccess;
var RemotePending = /** @class */ (function () {
    function RemotePending() {
        this._tag = 'RemotePending';
    }
    RemotePending.prototype.alt = function (fy) {
        return fy;
    };
    RemotePending.prototype.altL = function (fy) {
        return fy();
    };
    RemotePending.prototype.ap = function (fab) {
        return fab.fold(exports.initial, exports.pending, function () { return exports.pending; }, function () { return exports.pending; }); //tslint:disable-line no-use-before-declare
    };
    RemotePending.prototype.chain = function (f) {
        return exports.pending; //tslint:disable-line no-use-before-declare
    };
    RemotePending.prototype.extend = function (f) {
        return exports.pending; //tslint:disable-line no-use-before-declare
    };
    RemotePending.prototype.fold = function (initial, pending, failure, success) {
        return pending;
    };
    RemotePending.prototype.foldL = function (initial, pending, failure, success) {
        return pending();
    };
    RemotePending.prototype.getOrElseL = function (f) {
        return f();
    };
    RemotePending.prototype.map = function (f) {
        return this;
    };
    RemotePending.prototype.mapLeft = function (f) {
        return exports.pending; //tslint:disable-line no-use-before-declare
    };
    RemotePending.prototype.getOrElse = function (value) {
        return value;
    };
    RemotePending.prototype.reduce = function (f, b) {
        return b;
    };
    RemotePending.prototype.isInitial = function () {
        return false;
    };
    RemotePending.prototype.isPending = function () {
        return true;
    };
    RemotePending.prototype.isFailure = function () {
        return false;
    };
    RemotePending.prototype.isSuccess = function () {
        return false;
    };
    RemotePending.prototype.toOption = function () {
        return Option_1.none;
    };
    RemotePending.prototype.toNullable = function () {
        return null;
    };
    RemotePending.prototype.toString = function () {
        return 'pending';
    };
    RemotePending.prototype.contains = function (S, a) {
        return false;
    };
    RemotePending.prototype.exists = function (p) {
        return false;
    };
    return RemotePending;
}());
exports.RemotePending = RemotePending;
//Monad
var of = function (value) { return new RemoteSuccess(value); };
var ap = function (fab, fa) { return fa.ap(fab); };
var map = function (fa, f) { return fa.map(f); };
var chain = function (fa, f) { return fa.chain(f); };
//Foldable
var reduce = function (fa, b, f) { return fa.reduce(f, b); };
function traverse(F) {
    return function (ta, f) {
        if (ta.isSuccess()) {
            return F.map(f(ta.value), of);
        }
        else {
            return F.of(ta);
        }
    };
}
//Alt
var alt = function (fx, fy) { return fx.alt(fy); };
//Extend
var extend = function (fla, f) { return fla.extend(f); };
//constructors
exports.failure = function (error) { return new RemoteFailure(error); };
exports.success = of;
exports.pending = new RemotePending();
exports.initial = new RemoteInitial();
//Alternative
var zero = function () { return exports.initial; };
//filters
exports.isFailure = function (data) { return data.isFailure(); };
exports.isSuccess = function (data) { return data.isSuccess(); };
exports.isPending = function (data) { return data.isPending(); };
exports.isInitial = function (data) { return data.isInitial(); };
//Setoid
exports.getSetoid = function (SL, SA) {
    return {
        equals: function (x, y) {
            return x.foldL(function () { return y.isInitial(); }, function () { return y.isPending(); }, function (xError) { return y.foldL(function_1.constFalse, function_1.constFalse, function (yError) { return SL.equals(xError, yError); }, function_1.constFalse); }, function (ax) { return y.foldL(function_1.constFalse, function_1.constFalse, function_1.constFalse, function (ay) { return SA.equals(ax, ay); }); });
        },
    };
};
//Ord
exports.getOrd = function (OL, OA) {
    return tslib_1.__assign({}, exports.getSetoid(OL, OA), { compare: function (x, y) {
            return Ordering_1.sign(x.foldL(function () { return y.fold(0, -1, function () { return -1; }, function () { return -1; }); }, function () { return y.fold(1, 0, function () { return -1; }, function () { return -1; }); }, function (xError) { return y.fold(1, 1, function (yError) { return OL.compare(xError, yError); }, function () { return -1; }); }, function (xValue) { return y.fold(1, 1, function () { return 1; }, function (yValue) { return OA.compare(xValue, yValue); }); }));
        } });
};
//Semigroup
exports.getSemigroup = function (SL, SA) {
    return {
        concat: function (x, y) {
            return x.foldL(function () { return y.fold(y, y, function () { return y; }, function () { return y; }); }, function () { return y.fold(x, y, function () { return y; }, function () { return y; }); }, function (xError) { return y.fold(x, x, function (yError) { return exports.failure(SL.concat(xError, yError)); }, function () { return y; }); }, function (xValue) { return y.fold(x, x, function () { return x; }, function (yValue) { return exports.success(SA.concat(xValue, yValue)); }); });
        },
    };
};
//Monoid
exports.getMonoid = function (ML, MA) {
    return tslib_1.__assign({}, exports.getSemigroup(ML, MA), { empty: exports.initial });
};
function fromOption(option, error) {
    if (Option_1.isNone(option)) {
        return exports.failure(error());
    }
    else {
        return exports.success(option.value);
    }
}
exports.fromOption = fromOption;
function fromEither(either) {
    if (Either_1.isLeft(either)) {
        return exports.failure(either.value);
    }
    else {
        return exports.success(either.value);
    }
}
exports.fromEither = fromEither;
function fromPredicate(predicate, whenFalse) {
    return function (a) { return (predicate(a) ? exports.success(a) : exports.failure(whenFalse(a))); };
}
exports.fromPredicate = fromPredicate;
//instance
exports.remoteData = {
    //HKT
    URI: exports.URI,
    //Monad
    of: of,
    ap: ap,
    map: map,
    chain: chain,
    //Foldable
    reduce: reduce,
    //Traversable
    traverse: traverse,
    //Alt
    alt: alt,
    //Alternative
    zero: zero,
    //Extend
    extend: extend,
};
function combine() {
    var list = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        list[_i] = arguments[_i];
    }
    if (list.length === 0) {
        return of([]);
    }
    return Traversable_1.sequence(exports.remoteData, Array_1.array)(list);
}
exports.combine = combine;
